export const ADMIN_API_CONFIG = {
  BASE_URL:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://api.revuai.site"
      : "http://localhost:3001"),
  WS_BASE_URL:
    process.env.REACT_APP_WS_URL ||
    (process.env.NODE_ENV === "production"
      ? "wss://bbagrlo44d433555dlvi.containers.yandexcloud.net"
      : "http://localhost:3001"),
  ENDPOINTS: {
    ADMIN_LOGIN: "/api/auth/admin/login",
    ADMIN_ME: "/api/auth/admin/me",
  },
};

export const getApiUrl = (endpoint: string): string => {
  return `${ADMIN_API_CONFIG.BASE_URL}${endpoint}`;
};
